import { Action, createReducer, on } from '@ngrx/store';
import * as ProgramListActions from '../actions/program-list.actions';

export const carmProgramsListKey = 'carm-programs-list';

export interface ProgramsListState {
  inactivePrograms: string[];
  loading: boolean;
  success: boolean;
  error: any;
}

export const initialState: ProgramsListState = {
  inactivePrograms: [],
  loading: false,
  success: false,
  error: null,
};

const Reducer = createReducer(
  initialState,
  on(ProgramListActions.loadInactivePrograms, (state) => ({...state, loading: true, success: false})),
  on(ProgramListActions.loadInactiveProgramsSuccess, (state, {data}) => {
        return data ? { ...state, inactivePrograms: data, loading: false, success: true} : {...state,loading: false, success: true};
   }),
  on(ProgramListActions.loadInactiveProgramsFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
);

export function programListReducer(state: ProgramsListState | undefined, action: Action) {
  return Reducer(state, action);
}
